// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1j-1Y","amount":"Amount_amount__2kope","tip":"Amount_tip__1G-6N","tipHeader":"Amount_tipHeader__2YQBF","tipsWrap":"Amount_tipsWrap__T0zTj"};